import { useMemo } from 'react'
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import { BlendxCard } from '@blend-ed/blendx-ui';
import courseDataParser from '../../../utils/courseDataParser'
import { useDiscoverCourses } from '../../../hooks/courses/useFetchCourses'
import messages from '../../../components/messages';
import { useCurrency } from '@blend-ed/blendx-platform/hooks';

function TopCourses({ curr_course_id, intl }) {
    const { discoverCourses, loading } = useDiscoverCourses()
    const { symbol } = useCurrency()
    const topCourses = useMemo(() => {
        if (discoverCourses) {
            return courseDataParser(discoverCourses).filter(course => course.id !== curr_course_id)
        }
        return []
    }, [discoverCourses, curr_course_id])

    if (topCourses.length == 0) {
        return null
    }

    return (<div className="course-single__popular-course">
        <h3 className='course-single__description-title'>{intl.formatMessage(messages.topCoursesTitle)}</h3>
        <div className='course-single__popular-course-cards-wrapper'>
            {
                topCourses.slice(0, 3).map((course, index) => (
                    <BlendxCard
                        key={index}
                        title={course.name}
                        image={course.imageUrl}
                        estimatedTime={course.effort}
                        price={course.price}
                        type="price"
                        variant="course"
                        link={`/course/${course.id}`}
                        courseId={course.id}
                        currency={symbol}
                    />
                ))
            }
        </div>
    </div>)
}

TopCourses.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(TopCourses)
